import { BaseApi } from './base.api.js';
import { UPLOAD_FILE_TIMEOUT_MS } from '@repo/contracts';
import { resolveOnUploadProgress, uploadAxiosConfig } from '../utils/upload-axios-config.js';

export class ControlApi extends BaseApi {
    constructor(client) {
        super(client, '/control');
    }

    getCurrentEvaluation(id) {
        return this.client.get(`${this.basePath}/${id}/evaluation/current`);
    }

    getStandardsMapping(id, params = {}) {
        return this.client.get(`${this.basePath}/${id}/standards`, { params });
    }

    getScopeOptions() {
        return this.client.get(`${this.basePath}/scope/options`);
    }

    getCategoryOptions() {
        return this.client.get(`${this.basePath}/category/options`);
    }

    getScopePreference() {
        return this.client.get(`${this.basePath}/scope-preference`);
    }

    updateScopePreference(data = {}) {
        return this.client.put(`${this.basePath}/scope-preference`, data);
    }

    getEvaluationHistory(id, params = {}) {
        return this.client.get(`${this.basePath}/${id}/evaluation/history`, { params });
    }

    createEvaluationVersion(id, data = {}) {
        return this.client.post(`${this.basePath}/${id}/evaluation`, data);
    }

    uploadEvaluationEvidence(id, data, optionsOrCallback) {
        return this.client.post(
            `${this.basePath}/${id}/evidence`,
            data,
            uploadAxiosConfig({
                timeout: UPLOAD_FILE_TIMEOUT_MS,
                onUploadProgress: resolveOnUploadProgress(optionsOrCallback),
            }),
        );
    }

    downloadEvaluationEvidence(id, evidenceFileName) {
        return this.client.get(`${this.basePath}/${id}/evidence/${evidenceFileName}`, {
            responseType: 'blob'
        });
    }

    deleteEvaluationEvidence(id, evidenceFileName) {
        return this.client.delete(`${this.basePath}/${id}/evidence/${evidenceFileName}`);
    }

    getRelatedAssessmentQuestions(id, params = {}) {
        return this.client.get(`${this.basePath}/${id}/assessment-questions`, { params });
    }

    linkAssessmentQuestions(id, data = {}) {
        return this.client.post(`${this.basePath}/${id}/assessment-questions/link`, data);
    }

    unlinkAssessmentQuestion(id, questionId) {
        return this.client.delete(`${this.basePath}/${id}/assessment-questions/${questionId}/unlink`);
    }

    bulkUnlinkAssessmentQuestions(id, data = {}) {
        return this.client.post(`${this.basePath}/${id}/assessment-questions/bulk-unlink`, data);
    }

    deleteRelatedAssessmentQuestion(id, questionId) {
        return this.client.delete(`${this.basePath}/${id}/assessment-questions/${questionId}`);
    }

    bulkDeleteRelatedAssessmentQuestions(id, data = {}) {
        return this.client.post(`${this.basePath}/${id}/assessment-questions/bulk-delete`, data);
    }

    getSoaList(params = {}) {
        return this.client.get(`${this.basePath}/soa-list`, { params });
    }

    getSoaStats() {
        return this.client.get(`${this.basePath}/soa-stats`);
    }

    getRelatedDocuments(id, params = {}) {
        return this.client.get(`${this.basePath}/${id}/related-documents`, { params });
    }

    linkDocuments(id, data = {}) {
        return this.client.post(`${this.basePath}/${id}/related-documents/link`, data);
    }

    unlinkDocument(id, documentId) {
        return this.client.delete(`${this.basePath}/${id}/related-documents/${documentId}/unlink`);
    }

    bulkUnlinkDocuments(id, data = {}) {
        return this.client.post(`${this.basePath}/${id}/related-documents/bulk-unlink`, data);
    }
}
